<template>
    <div>
        <api-errors v-if="errors" :errors="errors" />
        <a v-if="mutableFavouriteInfo.exists" @click="deleteFavourite(mutableFavouriteInfo.id)">
            <i v-if="loadingDelete" class="fa fa-spinner fa-spin text-center" aria-hidden="true" />
            <i v-else class="fa fa-bookmark fa-fw" title="Remove from my favourite items" />

        </a>
        <a v-else @click="createFavourite()">
            <i v-if="loadingCreate" class="fa fa-spinner fa-spin text-center" aria-hidden="true" />
            <i v-else class="fa fa-bookmark-o fa-fw" title="Add to my favourite items" />
        </a>
    </div>
</template>

<script>
import ApiRequest from 'src/mixins/api-request.js'
import ApiErrors from '@/ApiErrorDisplay.vue'
export default {
    name: "ToggleFavourite",

    components:{
        ApiErrors
    },

    mixins: [ApiRequest],

    props: {
        itemUuid: {
            type: String,
            required: true
        },

        initialFavouriteInfo: {
            type: Object,
            required: true,
        },

        baseEndPoint: {
            type: String,
            default: ''
        }
    },

    data: () => ({
        errors: {},
        mutableFavouriteInfo: {},
        loadingCreate: false,
        loadingDelete: false
    }),

    watch: {
        initialFavouriteInfo: function() {
            this.mutableFavouriteInfo = this.initialFavouriteInfo
        }
    },

    mounted() {
        this.mutableFavouriteInfo = this.initialFavouriteInfo
    },

    methods: {
        createFavourite: function() {
            this.loadingCreate = true
            this.post(
                this.baseEndPoint,
                {item_uuid: this.itemUuid}
            ).then((response) => {
                this.mutableFavouriteInfo = {
                    'exists' : true,
                    'id' : response.data.id
                }
                this.$emit('update-favourite-info', {
                    'favouriteInfo': this.mutableFavouriteInfo,
                    'itemUuid': this.itemUuid
                })
                this.errors = {}

            }).catch((error) => {
                this.errors = error.response.data
            }).finally(() => {
                this.loadingCreate = false
            })
        },

        deleteFavourite: function(id) {
            this.loadingDelete = true
            this.delete(
                this.baseEndPoint + id + '/'
            ).then(() => {
                this.mutableFavouriteInfo = {
                    'exists' : false,
                    'id' : null
                }

                this.$emit('update-favourite-info', {
                    'favouriteInfo': this.mutableFavouriteInfo,
                    'itemUuid': this.itemUuid
                })
            }).catch((error) => {
                this.errors = error.response.data
            }).finally(() => {
                this.loadingDelete = false
            })
        }
    }
}
</script>
